import React from 'react';
import {
    DataGridPro,
    DataGridProProps,
} from '@mui/x-data-grid-pro';
import CustomGridToolbar from "../CustomGridToolbar";

export type ClassGridProps = Omit<DataGridProProps, 'columns' | 'checkboxSelection' | 'components'>

export default function ActivityGrid(props: ClassGridProps): JSX.Element {
    const {
        ...rest
    } = props;

    const columns = [
        { field: 'id', headerName: 'ID', width: 120, hide: true },
        { field: 'dateTime', headerName: 'Date/Time', width: 150 },
        { field: 'activity', headerName: 'Activity', width: 150 },
        { field: 'workOrder', headerName: 'Workorder #', width: 150 },
        { field: 'workOrderDT', headerName: 'Workorder Create Date/Time', width: 150 },
        { field: 'workOrderReqDT', headerName: 'Workorder Required By', width: 200 },
        { field: 'requestor', headerName: 'Requestor', width: 200 },
        { field: 'webOrderTrack', headerName: 'Web Order Tracking #', width: 200 },
        { field: 'comment', headerName: 'Comment', width: 200 },
        { field: 'webOrderBatch', headerName: 'Web Order Batch #', width: 200 },
    ];

    return (
        <DataGridPro
            {...rest}
            disableColumnMenu
            disableColumnReorder
            disableSelectionOnClick
            columns={columns}
            components={{
                Toolbar: CustomGridToolbar,
            }}
        />
    );
}
